import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-payment-view',
  templateUrl: './payment-view.component.html',
  styleUrls: ['./payment-view.component.scss']
})
export class PaymentViewComponent implements OnInit {
  possibleMethods = ["Check", "Cash"];
  
  @Input()
  property; 

  @Input()
  payment;

  constructor() { }

  ngOnInit() {
  }

}
